export default __webpack_public_path__ + "static/avatar-b64c5b95e34d2b21a5e567ac6fc5f256.png";